import { inject } from '@angular/core';
import { AccessState, FeatureMenuItemService, RouterLinkResolverPipe } from '@core/frontend-shared';
import { Store } from '@ngxs/store';
import { map } from 'rxjs/operators';
import { takeWhileAlive } from '@core/frontend-shared/utils';
import { NgClass, AsyncPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ScreenService } from '@common/ui/frontend-shared/screen-service';
import { OpenConsoleDirective } from '@common/console/frontend-shared';
import { UiButtonComponent } from '@common/ui/frontend-shared/button';
import { UiLogoComponent } from '@common/ui/frontend-shared/logo/logo';
import * as i0 from "@angular/core";
import * as i1 from "@common/ui/frontend-shared/screen-service";
import * as i2 from "@core/frontend-shared";
const _c0 = [[["", 8, "top-menu-item"]], [["", 8, "content-left"]], [["", 8, "content-right"]]];
const _c1 = [".top-menu-item", ".content-left", ".content-right"];
const _c2 = a0 => ({
  "colored": a0
});
const _c3 = () => ["/"];
function LayoutFrontpageComponent_Conditional_13_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "a", 8);
    i0.ɵɵpipe(1, "resolveRouterLink");
  }
  if (rf & 2) {
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(1, 1, "login"));
  }
}
function LayoutFrontpageComponent_Conditional_13_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "a", 9);
    i0.ɵɵpipe(1, "resolveRouterLink");
  }
  if (rf & 2) {
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(1, 1, "profile"));
  }
}
function LayoutFrontpageComponent_Conditional_13_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "a", 10);
    i0.ɵɵpipe(1, "resolveRouterLink");
  }
  if (rf & 2) {
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(1, 1, "management"));
  }
}
function LayoutFrontpageComponent_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵconditionalCreate(1, LayoutFrontpageComponent_Conditional_13_Conditional_1_Template, 2, 3, "a", 8);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵconditionalCreate(3, LayoutFrontpageComponent_Conditional_13_Conditional_3_Template, 2, 3, "a", 9);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "async");
    i0.ɵɵconditionalCreate(6, LayoutFrontpageComponent_Conditional_13_Conditional_6_Template, 2, 3, "a", 10);
    i0.ɵɵpipe(7, "async");
    i0.ɵɵpipe(8, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(!i0.ɵɵpipeBind1(2, 3, ctx_r0.isLoggedIn$) ? 1 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(i0.ɵɵpipeBind1(4, 5, ctx_r0.isLoggedIn$) && !i0.ɵɵpipeBind1(5, 7, ctx_r0.hasManagementMenu$) ? 3 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(i0.ɵɵpipeBind1(7, 9, ctx_r0.isLoggedIn$) && i0.ɵɵpipeBind1(8, 11, ctx_r0.hasManagementMenu$) ? 6 : -1);
  }
}
export let LayoutFrontpageComponent = /*#__PURE__*/(() => {
  class LayoutFrontpageComponent {
    constructor(screen, featureMenuItemService) {
      this.screen = screen;
      this.theme = 'berry';
      this.showBottomButtons = true;
      this.loggedIn$ = inject(Store).select(AccessState.loggedIn);
      this.logoSize$ = screen.windowWidth$.pipe(takeWhileAlive(), map(width => {
        if (width > 1300) return 240;
        if (width > 1024) return 210;
        if (width > 768) return 150;
        return 100;
      }));
      this.hasManagementMenu$ = featureMenuItemService.hasAccessibleMenuItems('managementToolbar');
    }
    static {
      this.ɵfac = function LayoutFrontpageComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LayoutFrontpageComponent)(i0.ɵɵdirectiveInject(i1.ScreenService), i0.ɵɵdirectiveInject(i2.FeatureMenuItemService));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: LayoutFrontpageComponent,
        selectors: [["pflegetheke-layout-frontpage"]],
        inputs: {
          theme: "theme",
          showBottomButtons: "showBottomButtons"
        },
        ngContentSelectors: _c1,
        decls: 14,
        vars: 16,
        consts: [["ui-theme", "dark", 1, "wrapper", 3, "ngClass"], [1, "top-menu", 3, "ngClass"], [1, "left", "content", 3, "ngClass"], [1, "logo", 3, "routerLink"], ["openConsole", "", 3, "scaling", "background", "outline"], [1, "right", "box-primary-darker", 3, "ngClass"], [1, "main", "content"], [1, "bottom"], ["iconPos", "right", "uiButton", "", "icon", "unlock", "label", "Anmeldung", 1, "ui-button-outline", 3, "routerLink"], ["iconPos", "right", "uiButton", "", "icon", "user", "label", "Mein Profil", 1, "ui-button-outline", 3, "routerLink"], ["iconPos", "right", "uiButton", "", "icon", "university", "label", "Management", 1, "ui-button-outline", 3, "routerLink"]],
        template: function LayoutFrontpageComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c0);
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵpipe(2, "async");
            i0.ɵɵprojection(3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 2);
            i0.ɵɵprojection(5, 1);
            i0.ɵɵelementStart(6, "a", 3);
            i0.ɵɵelement(7, "ui-logo", 4);
            i0.ɵɵpipe(8, "async");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(9, "div", 5)(10, "div", 6);
            i0.ɵɵprojection(11, 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(12, "div", 7);
            i0.ɵɵconditionalCreate(13, LayoutFrontpageComponent_Conditional_13_Template, 9, 13, "div");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", "theme-" + ctx.theme);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c2, i0.ɵɵpipeBind1(2, 9, ctx.screen.isDesktop$)));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngClass", ctx.theme === "berry" ? "box-contrast" : "box-secondary");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction0(15, _c3));
            i0.ɵɵadvance();
            i0.ɵɵproperty("scaling", i0.ɵɵpipeBind1(8, 11, ctx.logoSize$))("background", true)("outline", false);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", ctx.theme === "berry" ? "box-primary" : "box-primary-dark");
            i0.ɵɵadvance(4);
            i0.ɵɵconditional(ctx.showBottomButtons ? 13 : -1);
          }
        },
        dependencies: [NgClass, RouterLink, UiLogoComponent, OpenConsoleDirective, UiButtonComponent, AsyncPipe, RouterLinkResolverPipe],
        styles: [".wrapper[_ngcontent-%COMP%]{min-height:100%;flex:1;background:var(--primaryDarkColor)}[_nghost-%COMP%]{border-bottom:1px solid #0a1032;position:absolute;inset:0;display:block}[_nghost-%COMP%]   .content[_ngcontent-%COMP%]     h2{font-size:1.8rem;line-height:1.1;margin:0}[_nghost-%COMP%]   .content[_ngcontent-%COMP%]     h2+p.subline{font-size:1.2rem;margin:0}[_nghost-%COMP%]   .content[_ngcontent-%COMP%]     p+h2{margin-top:25px}[_nghost-%COMP%]   .content[_ngcontent-%COMP%]{--inputBgColor: transparent;--inputBorderColor: #5761ac;--inputHoverBorderColor: #fff;--inputHoverBgColor: rgba(255,255,255,.05);--checkboxBorderColor: #fff --checkboxBgColor: transparent --checkboxHoverBgColor: rgba(255,255,255,.05);--checkboxHoverBorderColor: var(--primaryColor);--tableBodyRowBgColor:#222d62;--tableBodyRowEvenBgColor:#273267;--validationErrorTextColor:#ff7777;--tabViewTextColor:var(--primaryTextColor)}[_nghost-%COMP%]     .ui-button.ui-button-text-hover, [_nghost-%COMP%]     .ui-button.ui-button-outline{border-width:2px;--buttonBgColor:transparent!important;--buttonBorderColor:var(--primaryColor)!important;--buttonIconColor:var(--primaryColor)!important;--buttonTextColor:var(--primaryTextColor)!important;--buttonHoverBorderColor:var(--primaryTextColor)!important;--buttonHoverIconColor:var(--primaryTextColor)!important;--buttonHoverTextColor:var(--primaryTextColor)!important;--buttonActiveBorderColor:var(--primaryTextColor)!important}[_nghost-%COMP%]     .ui-button.ui-button-primary{--buttonHoverBgColor:var(--contrastColor);--buttonHoverBorderColor:var(--contrastColor)}.top-menu[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;align-items:center;padding:20px;z-index:20;position:absolute;right:0;top:0}.top-menu[_ngcontent-%COMP%]    >*{margin:0 0 0 10px}.top-menu.colored[_ngcontent-%COMP%]{padding:20px}@media (max-width: 479px){.top-menu[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{font-size:.8rem}}.left[_ngcontent-%COMP%]{position:relative;flex:2;padding:20px;min-height:320px;display:flex;align-items:center}.left[_ngcontent-%COMP%]   .logo[_ngcontent-%COMP%]{position:absolute;bottom:20px;right:20px}.right[_ngcontent-%COMP%]{position:relative;flex:3;display:flex;flex-direction:column}.right[_ngcontent-%COMP%] > .main[_ngcontent-%COMP%]{padding:40px 20px}.right[_ngcontent-%COMP%] > .bottom[_ngcontent-%COMP%]{padding:0 40px 40px;text-align:center}.right[_ngcontent-%COMP%] > .bottom[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{margin:5px}@media (min-width: 960px){.right[_ngcontent-%COMP%]{overflow:auto;height:calc(100vh - var(--bottombarHeight) - 1px)}}@media (min-width: 480px){[_nghost-%COMP%]   .content[_ngcontent-%COMP%]     h2{font-size:2rem}[_nghost-%COMP%]   .content[_ngcontent-%COMP%]     h2+p{font-size:1.2rem}[_nghost-%COMP%]   .content[_ngcontent-%COMP%]     .left{min-height:320px}}@media (min-width: 640px){.left[_ngcontent-%COMP%]{min-height:60vw}.left[_ngcontent-%COMP%]{padding:40px 20px 40px 40px}.right[_ngcontent-%COMP%] > .main[_ngcontent-%COMP%]{padding:70px 20px 30px}.right[_ngcontent-%COMP%] > .bottom[_ngcontent-%COMP%]{text-align:right}}@media (min-width: 960px){.wrapper[_ngcontent-%COMP%]{display:flex!important;justify-content:stretch}.left[_ngcontent-%COMP%]{flex:1;max-width:100vh;display:flex;align-items:center;justify-content:flex-end;min-height:initial}[_nghost-%COMP%]   .left.content[_ngcontent-%COMP%]     h2{text-align:right}.right[_ngcontent-%COMP%]{flex:1;min-height:calc(100vh - 40vw)}.right[_ngcontent-%COMP%] > .main[_ngcontent-%COMP%]{flex:3;display:flex;flex-direction:column;justify-content:center}.right[_ngcontent-%COMP%] > .top-menu[_ngcontent-%COMP%]{height:100px}.right[_ngcontent-%COMP%] > .bottom[_ngcontent-%COMP%]{height:100px}}@media (min-width: 1300px){.left[_ngcontent-%COMP%], .right[_ngcontent-%COMP%]{flex:1}[_nghost-%COMP%]   .content[_ngcontent-%COMP%]     h2{font-size:2.2rem}[_nghost-%COMP%]   .content[_ngcontent-%COMP%]     h2+p.subline{font-size:1.4rem}}@media (min-width: 1800px){[_nghost-%COMP%]   .content[_ngcontent-%COMP%]     h2{font-size:2.8rem}[_nghost-%COMP%]   .content[_ngcontent-%COMP%]     h2+p.subline{font-size:1.7rem}}@media (min-width: 2200px){[_nghost-%COMP%]   .content[_ngcontent-%COMP%]     h2{font-size:3.5rem}[_nghost-%COMP%]   .content[_ngcontent-%COMP%]     h2+p.subline{font-size:2rem}}@media (max-width: 768px){.bottom[_ngcontent-%COMP%]{margin-bottom:60px}}"]
      });
    }
  }
  return LayoutFrontpageComponent;
})();